<template>
  <div id="bom-custom-config-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main" >
      <div class="title-area" id="modal-moving">
        <h2>構成明細カスタム設定</h2>
      </div>
      <div class="data-area">
        <div class="error_message">{{ errorMessage.text }}</div>
        <ul>
          <li v-for="(num,index) in 10" :key="index">
            <span class="label">カスタム名{{ num }}</span>
            <input type="text" v-model="customNameGroup[num]">
          </li>
        </ul>
      </div>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName1'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName2'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName3'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName4'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName5'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName6'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName7'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName8'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName9'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['bomCustomName10'] }}</p>
      <div class="button-area">
        <button type="button" class="main_btn" @click="updateBomCustom">OK</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import {API_URL} from '../../constants/App'
export default {
  name: 'BomCustomConfigModal',
  props: {
    prevDialog: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** カスタム名グループ */
      customNameGroup: {1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: ''},
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.modalShown = false
      this.prevDialog()
    },
    /** カスタム名の取得 */
    getBomCustom: function () {
      axios.get(API_URL.ADMIN + '/get-bom-custom'
      ).then(response => {
        let data = response.data.data
        this.customNameGroup[1] = data.bomCustomName1
        this.customNameGroup[2] = data.bomCustomName2
        this.customNameGroup[3] = data.bomCustomName3
        this.customNameGroup[4] = data.bomCustomName4
        this.customNameGroup[5] = data.bomCustomName5
        this.customNameGroup[6] = data.bomCustomName6
        this.customNameGroup[7] = data.bomCustomName7
        this.customNameGroup[8] = data.bomCustomName8
        this.customNameGroup[9] = data.bomCustomName9
        this.customNameGroup[10] = data.bomCustomName10
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** カスタム名の更新 */
    updateBomCustom: function () {
      let payload = {
        bomCustomName1: this.customNameGroup[1],
        bomCustomName2: this.customNameGroup[2],
        bomCustomName3: this.customNameGroup[3],
        bomCustomName4: this.customNameGroup[4],
        bomCustomName5: this.customNameGroup[5],
        bomCustomName6: this.customNameGroup[6],
        bomCustomName7: this.customNameGroup[7],
        bomCustomName8: this.customNameGroup[8],
        bomCustomName9: this.customNameGroup[9],
        bomCustomName10: this.customNameGroup[10]
      }
      axios.post(API_URL.ADMIN + '/update-bom-custom', payload
      ).then(responce => {
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.prevDialog()
          }
        }
        this.errorMessage = {}
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    }
  },
  created: function () {
    this.getBomCustom()
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 18px;
  .label{
    min-width: 110px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/BomCustomConfigModal.vue